/* eslint-disable no-console */
import { usePostHog } from "posthog-js/react"
import { useCallback } from "react"
import { User } from "@/feature/auth/api/types"

export const useIdentify = () => {
  const posthog = usePostHog()

  const isAlreadyIdentified = useCallback(
    (user: User) => posthog.get_distinct_id() === user.email,
    [posthog]
  )

  const identifyUser = useCallback(
    (user?: User | null) => {
      if (!user) return
      if (isAlreadyIdentified(user)) return
      if (import.meta.env.VITE_POSTHOG_ENABLED === `false`) {
        console.log(`PostHog is disabled, skipping identifyUser`)
        return
      }
      posthog.identify(user.email, {
        name: user.name,
        workspace: user.workspaces?.[0]?.id,
      })
      console.log(`identified user`, user.email)
    },
    [isAlreadyIdentified, posthog]
  )

  const resetIdentify = useCallback(() => {
    if (import.meta.env.VITE_POSTHOG_ENABLED === `false`) {
      console.log(`PostHog is disabled, skipping resetIdentify`)
      return
    }
    posthog.reset()
  }, [posthog])

  return {
    identifyUser,
    resetIdentify,
    isAlreadyIdentified,
  }
}
